// extracted by mini-css-extract-plugin
module.exports = {"up":"RankChange_up__2RG8j","down":"RankChange_down__PdcZU","increment":"RankChange_increment__2aOa1"};